import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RelatedServices = () => {
  const relatedServices = [
    {
      title: 'Corporate Law',
      description: 'Business structuring, compliance, and corporate governance services for your organization.',
      icon: 'Building2',
      link: '/individual-practice-area-detail?area=corporate-law'
    },
    {
      title: 'Civil Litigation',
      description: 'Professional representation in civil disputes and commercial litigation matters.',
      icon: 'Scale',
      link: '/civil-litigation'
    },
    {
      title: 'Property Law',
      description: 'Comprehensive property law services including transactions and dispute resolution.',
      icon: 'Home',
      link: '/individual-practice-area-detail?area=property-law'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
            Related Legal Services
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Explore our other practice areas that complement our employment law services
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {relatedServices.map((service, index) => (
            <Link
              key={index}
              to={service.link}
              className="group bg-gradient-to-br from-surface/20 to-primary/5 rounded-2xl p-8 border border-border-light hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <Icon name={service.icon} size={24} color="white" strokeWidth={2} />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-heading font-semibold text-text-primary mb-3 group-hover:text-primary transition-colors duration-200">
                    {service.title}
                  </h3>
                  <p className="text-text-secondary leading-relaxed">
                    {service.description}
                  </p>
                  <div className="mt-4 flex items-center text-primary font-medium">
                    <span className="text-sm">Learn More</span>
                    <Icon name="ArrowRight" size={16} className="ml-2 group-hover:translate-x-1 transition-transform duration-200" />
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RelatedServices;